export default {
  name: "收不到手机验证码可能是由于以下原因造成的，请进行排查",
  point: [
    {
      name: "手机号错误",
      description:
        "你查看的手机不是系统给您发送验证码的手机号，会导致你无法接收到手机号码。"
    },
    {
      name: "你的手机欠费",
      description:
        "当手机无法接收验证码时，有可能是因为手机欠费导致停机，从而无法正常收发短信。"
    },
    {
      name: "黑名单软件拦截",
      description:
        "你手机将系统给你发送验证码的号码加入了黑名单或是被手机中所安装的安全软件拦截，也会导致无法收到验证码。"
    },
    {
      name: "网络环境差",
      description:
        "最好不要在信号较差的地方进行验证，这样不仅会出现延迟接收验证码或者无法接收验证码的情况，还会导致手机电量降低。"
    },
    {
      name: "向运营商申请过屏蔽",
      description:
        "如果曾经把某些通知类短信向运营商投诉为垃圾短信，那么该类短信会被运营商屏蔽，手机就无法接收该类信息了。我们可以先拨打手机运营商的客服电话，核实问题后，向运营商申请撤销屏蔽即可。"
    },
    {
      name: "系统发送方出现问题",
      description:
        "系统的短信发送平台有可能因为发送量过大导致给你发送的验证码没有成功，这时你可以重新发送几次验证码试试。如果以上都不行请通过“优课场域”公众号给我留言，并告知你的手机号_信息或其他联系方式，运维人员会给你处理并反馈。"
    }
  ]
};
